import * as React from "react";

const MinusCircleFaq: React.FC = () => {
    return (
        <svg
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
        >
            <circle cx="28" cy="28" r="20" fill="#FFD100" />
            <line x1="24" y1="28" x2="33" y2="28" stroke="#000000" strokeWidth="5" strokeLinecap="round" />
        </svg>
    );
};

export default React.memo(MinusCircleFaq);
